module.exports = __webpack_public_path__ + "static/media/client.c92b52f4.svg";